/**
 * Mega Menu Header — Desktop hover/keyboard + Mobile drawer
 * No dependencies. Vanilla JS. IIFE pattern.
 */
(function () {
  'use strict';

  var SELECTORS = {
    wrapper: '.header-wrapper--mega',
    trigger: '[data-mega-trigger]',
    button: '[data-mega-button]',
    panel: '[data-mega-panel]',
    overlay: '[data-mega-overlay]',
    mobileToggle: '[data-mobile-toggle]',
    mobileDrawer: '[data-mobile-drawer]',
    mobileClose: '[data-mobile-close]',
    mobileOpen: '[data-mobile-open]',
    mobileBack: '[data-mobile-back]',
    mobileLevel: '[data-mobile-level]'
  };

  var closeTimer = null;
  var activeItem = null;
  var CLOSE_DELAY = 150;

  // ── Desktop: Hover + Keyboard ───────────────────────────
  function initDesktop() {
    var triggers = document.querySelectorAll(SELECTORS.trigger);

    function cancelClose() {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    function doClose(li) {
      li.classList.remove('is-open');
      var b = li.querySelector(SELECTORS.button);
      var p = li.querySelector(SELECTORS.panel);
      if (b) b.setAttribute('aria-expanded', 'false');
      if (p) p.setAttribute('aria-hidden', 'true');
    }

    function closeAll() {
      cancelClose();
      if (activeItem) {
        doClose(activeItem);
        activeItem = null;
      }
    }

    function openItem(li) {
      cancelClose();
      if (activeItem === li) return;
      if (activeItem) doClose(activeItem);
      activeItem = li;
      var b = li.querySelector(SELECTORS.button);
      var p = li.querySelector(SELECTORS.panel);
      li.classList.add('is-open');
      if (b) b.setAttribute('aria-expanded', 'true');
      if (p) p.removeAttribute('aria-hidden');
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(closeAll, CLOSE_DELAY);
    }

    triggers.forEach(function (li) {
      var btn = li.querySelector(SELECTORS.button);
      var pnl = li.querySelector(SELECTORS.panel);
      if (!btn || !pnl) return;

      // Hover: open on enter, close on leave (with tiny safety delay)
      li.addEventListener('mouseenter', function () { openItem(li); });
      li.addEventListener('mouseleave', function () { scheduleClose(); });

      // The panel is a DOM child of <li>, so mouseleave on <li>
      // does NOT fire while pointer is inside the panel.
      // But as extra safety (position:absolute edge cases):
      pnl.addEventListener('mouseenter', function () { cancelClose(); });
      pnl.addEventListener('mouseleave', function () { scheduleClose(); });

      btn.addEventListener('click', function () {
        if (activeItem === li) { closeAll(); } else { openItem(li); }
      });

      // Keyboard
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); btn.focus(); }
      });

      pnl.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); btn.focus(); }
      });
    });
  }

  // ── Mobile: Drawer ──────────────────────────────────────
  function initMobile() {
    var toggle = document.querySelector(SELECTORS.mobileToggle);
    var drawer = document.querySelector(SELECTORS.mobileDrawer);
    var closeBtn = document.querySelector(SELECTORS.mobileClose);
    var overlay = document.querySelector(SELECTORS.overlay);

    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-active');
      document.body.classList.add('mega-mobile-drawer-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 100);
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('mega-mobile-drawer-open');
      document.body.style.overflow = '';
      resetMobileLevels();
      toggle.focus();
    }

    toggle.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    var openBtns = drawer.querySelectorAll('[data-mobile-open]');
    var backBtns = drawer.querySelectorAll(SELECTORS.mobileBack);
    var levels = drawer.querySelectorAll(SELECTORS.mobileLevel);

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetLevel = btn.getAttribute('data-mobile-open');
        showMobileLevel(levels, targetLevel);
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showMobileLevel(levels, '0');
        openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      });
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function showMobileLevel(levels, targetIndex) {
    levels.forEach(function (level) {
      var idx = level.getAttribute('data-mobile-level');
      if (idx === targetIndex) {
        level.classList.add('is-active');
      } else {
        level.classList.remove('is-active');
      }
    });
  }

  function resetMobileLevels() {
    var levels = document.querySelectorAll(SELECTORS.mobileLevel);
    levels.forEach(function (level) {
      var idx = level.getAttribute('data-mobile-level');
      if (idx === '0') {
        level.classList.add('is-active');
      } else {
        level.classList.remove('is-active');
      }
    });
  }

  // ── Cart Count: live update ──────────────────────────────
  function initCartCount() {
    var nativeFetch = window.fetch.bind(window);

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }

    function refreshCartCount() {
      nativeFetch(window.Shopify.routes.root + 'cart.json')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); })
        .catch(function () {});
    }

    // 1. Subscribe to theme's PUB_SUB if available (fires on add-to-cart)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        refreshCartCount();
      });
    }

    // 2. Intercept fetch to catch cart changes not covered by PUB_SUB
    //    (e.g. quantity change in cart drawer)
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      var isCartApi = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(urlStr);

      return nativeFetch.apply(window, arguments).then(function (response) {
        if (isCartApi) {
          setTimeout(refreshCartCount, 300);
        }
        return response;
      });
    };
  }

  // ── Init ────────────────────────────────────────────────
  function init() {
    initDesktop();
    initMobile();
    initCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
